import Typography from '@mui/material/Typography';
import { useProducts } from '../../../data-access/products/ProductsProvider';
import ProductsQueryEmptyState from './ProductsQueryEmptyState';
import { useProductsQuery } from '../contexts/ProductsQueryContext';
import ProductsSortForm from './products-query-filters/ProductsSortForm';

const ProductsResultsSummary: React.FC = () => {
  const { products, isLoading, isLoaded } = useProducts();
  const { searchTerm, onShowAllProducts } = useProductsQuery();

  return (
    <ProductsQueryEmptyState
      isLoading={isLoading}
      isLoaded={isLoaded}
      products={products}
      searchTerm={searchTerm}
      onShowAllProducts={onShowAllProducts}
      sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
    >
      <ProductsSortForm />
      <Typography variant="caption">{`${products.length} results`}</Typography>
    </ProductsQueryEmptyState>
  );
};

export default ProductsResultsSummary;
